import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Investors\CompaniesController::index
* @see app/Http/Controllers/Investors/CompaniesController.php:40
* @route '//app.finesthub.de/companies'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '//app.finesthub.de/companies',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Investors\CompaniesController::index
* @see app/Http/Controllers/Investors/CompaniesController.php:40
* @route '//app.finesthub.de/companies'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\CompaniesController::index
* @see app/Http/Controllers/Investors/CompaniesController.php:40
* @route '//app.finesthub.de/companies'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Investors\CompaniesController::index
* @see app/Http/Controllers/Investors/CompaniesController.php:40
* @route '//app.finesthub.de/companies'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Investors\CompaniesController::store
* @see app/Http/Controllers/Investors/CompaniesController.php:176
* @route '//app.finesthub.de/companies'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '//app.finesthub.de/companies',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Investors\CompaniesController::store
* @see app/Http/Controllers/Investors/CompaniesController.php:176
* @route '//app.finesthub.de/companies'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\CompaniesController::store
* @see app/Http/Controllers/Investors/CompaniesController.php:176
* @route '//app.finesthub.de/companies'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Investors\CompaniesController::show
* @see app/Http/Controllers/Investors/CompaniesController.php:119
* @route '//app.finesthub.de/companies/{company}'
*/
export const show = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '//app.finesthub.de/companies/{company}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Investors\CompaniesController::show
* @see app/Http/Controllers/Investors/CompaniesController.php:119
* @route '//app.finesthub.de/companies/{company}'
*/
show.url = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return show.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\CompaniesController::show
* @see app/Http/Controllers/Investors/CompaniesController.php:119
* @route '//app.finesthub.de/companies/{company}'
*/
show.get = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Investors\CompaniesController::show
* @see app/Http/Controllers/Investors/CompaniesController.php:119
* @route '//app.finesthub.de/companies/{company}'
*/
show.head = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Investors\CompaniesController::edit
* @see app/Http/Controllers/Investors/CompaniesController.php:241
* @route '//app.finesthub.de/companies/{company}/edit'
*/
export const edit = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

edit.definition = {
    methods: ["get","head"],
    url: '//app.finesthub.de/companies/{company}/edit',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Investors\CompaniesController::edit
* @see app/Http/Controllers/Investors/CompaniesController.php:241
* @route '//app.finesthub.de/companies/{company}/edit'
*/
edit.url = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return edit.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\CompaniesController::edit
* @see app/Http/Controllers/Investors/CompaniesController.php:241
* @route '//app.finesthub.de/companies/{company}/edit'
*/
edit.get = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Investors\CompaniesController::edit
* @see app/Http/Controllers/Investors/CompaniesController.php:241
* @route '//app.finesthub.de/companies/{company}/edit'
*/
edit.head = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: edit.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Investors\CompaniesController::update
* @see app/Http/Controllers/Investors/CompaniesController.php:248
* @route '//app.finesthub.de/companies/{company}'
*/
export const update = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put","patch"],
    url: '//app.finesthub.de/companies/{company}',
} satisfies RouteDefinition<["put","patch"]>

/**
* @see \App\Http\Controllers\Investors\CompaniesController::update
* @see app/Http/Controllers/Investors/CompaniesController.php:248
* @route '//app.finesthub.de/companies/{company}'
*/
update.url = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return update.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\CompaniesController::update
* @see app/Http/Controllers/Investors/CompaniesController.php:248
* @route '//app.finesthub.de/companies/{company}'
*/
update.put = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Investors\CompaniesController::update
* @see app/Http/Controllers/Investors/CompaniesController.php:248
* @route '//app.finesthub.de/companies/{company}'
*/
update.patch = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\Investors\CompaniesController::destroy
* @see app/Http/Controllers/Investors/CompaniesController.php:279
* @route '//app.finesthub.de/companies/{company}'
*/
export const destroy = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '//app.finesthub.de/companies/{company}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Investors\CompaniesController::destroy
* @see app/Http/Controllers/Investors/CompaniesController.php:279
* @route '//app.finesthub.de/companies/{company}'
*/
destroy.url = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return destroy.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\CompaniesController::destroy
* @see app/Http/Controllers/Investors/CompaniesController.php:279
* @route '//app.finesthub.de/companies/{company}'
*/
destroy.delete = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

const CompaniesController = { index, store, show, edit, update, destroy }

export default CompaniesController